export const isSpecialSeriesMatch = (seriesA: string, seriesB: string) => (seriesA === 'gr86' && seriesB === '86') || (seriesA === 'grsupra' && seriesB === 'supra');
